export class SettingsEmailMerge {
    static fromExistingData(data): SettingsEmailMerge {
        const setting = new SettingsEmailMerge();
        if (data.corporationNumberId) setting.corporationNumberId = data.corporationNumberId;
        if (data.corporationNumberName) setting.corporationNumberName = data.corporationNumberName;
        if (data.name) setting.name = data.name;
        if (data.emailSender) setting.emailSender = data.emailSender;
        if (data.emailSenderName) setting.emailSenderName = data.emailSenderName;
        if (data.draftAutoSave) setting.draftAutoSave = data.draftAutoSave;
        return setting;
    }

    constructor(
        public id: number = null,
        public corporationNumberId: number = null,
        public corporationNumberName: string = '',
        public name: string = '',
        public emailSender: string = '',
        public emailSenderName: string = '',
        public draftAutoSave: boolean = false,
        public staffNotificationSettings: Array<any> = [],
        public createdBy: string = '',
        public createdAt: string = '',
        public formFields = {
            emailSender: {editMode: false},
            emailSenderName: {editMode: false}
        },
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsEmailMerge.ts